export const SET_SERVICE_STATUS = 'setServiceStatus'
export const SET_ACCOUNT = 'setAccount'
export const SET_COMPANIES = 'setCompanies'
export const SET_ANNOUNCEMENT = 'setAnnouncement'
